// extracted by mini-css-extract-plugin
export default {"download":"saYgbrvk"};